export default class ProjectEvaluation {

	constructor() {
		this.id = 0;
		this.userId = 0;
		this.projectId = 0;
		this.evaluation = 0;
	}
}